module.exports = __webpack_public_path__ + "static/img/icon_monei.d39fa117.png";